// @ts-nocheck
import React from 'react'

import { browserHistory } from 'react-router'
import { CardActions, CardTitle } from 'material-ui/Card'
import FlatButton from 'material-ui/FlatButton'
import ListIcon from 'material-ui/svg-icons/action/list'

import api from '../../../api'
import CommentBotRunSummary from './summary'

const styles = {
  cardActions: {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
    padding: '14px 0',
    marginRight: -8
  }
}

class ShowCommentBotRun extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false,
      commentBotRun: null
    }
  }

  componentWillMount () {
    this.loadCommentBotRun()
      .then(() => {
        this.setState({ isLoaded: true })
      })
  }

  componentWillReceiveProps () {
    this.loadCommentBotRun()
      .then(() => {
        this.setState({ isLoaded: true })
      })
  }

  loadCommentBotRun () {
    return api.get(`admin/comment_bot_runs/${this.props.params.commentBotRunId}`)
      .then(res => res.json())
      .then(commentBotRun => {
        this.setState({ commentBotRun })
        return commentBotRun
      })
  }

  render () {
    if (!this.state.isLoaded) {
      return null
    }

    const { commentBotRun } = this.state

    return (
      <div>
        <CardActions style={styles.cardActions}>
          <FlatButton
            onClick={() => {
              browserHistory.push('/write-now/comment-bots/history')
            }}
            icon={<ListIcon />}
            title='Back to list'
          />
        </CardActions>

        <CardTitle title={`Comment Bot Run #${commentBotRun.id}`} />

        <CommentBotRunSummary commentBotRun={commentBotRun} />
      </div>
    )
  }
}

// @ts-ignore
ShowCommentBotRun.propTypes = {
  params: React.PropTypes.shape({
    commentBotRunId: React.PropTypes.string.isRequired
  }).isRequired
}

export default ShowCommentBotRun
